import { render } from "./roomViewTable.vue?vue&type=template&id=069babb0"
import script from "./roomViewTable.vue?vue&type=script&lang=js"
export * from "./roomViewTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__